/* Littl 2027 — product page: gallery + flip, variants, quantity, add to cart, pairs, floating bar, recommendations */
(() => {
  const root = document.querySelector('[data-l-pdp]');
  if (!root) return;
  document.body.classList.add('l-pdp-page');
  const R = window.routes || {};
  const addUrl = (R.cart_add_url || '/cart/add') + '.js';
  const cartUrl = (R.cart_url || '/cart') + '.js';
  const money = (c) => '₹' + (c / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 }).replace(/\.00$/, '');
  const $ = (s, el = root) => el.querySelector(s);
  const $$ = (s, el = root) => [...el.querySelectorAll(s)];

  /* ---------- gallery: peek carousel (phone) / main photo + thumbnails (desktop) ---------- */
  const gal = $('[data-l-gal]');
  const track = $('[data-track]');
  const slides = $$('[data-slide]');
  const bars = $$('.l-gal2__bar i');
  const label = $('[data-gal-label]');
  const flipLbl = $('[data-flip-label]');
  const desk = () => window.matchMedia('(min-width: 990px)').matches;
  let cur = 0;
  const paintGal = (i) => {
    cur = i;
    bars.forEach((b, k) => b.classList.toggle('is-on', k === i));
    slides.forEach((s, k) => s.classList.toggle('is-on', k === i));
    $$('[data-thumb]').forEach((t, k) => t.setAttribute('aria-current', String(k === i)));
    if (label) label.textContent = `${slides[i].dataset.label} · ${i + 1}/${slides.length}`;
    if (flipLbl) flipLbl.textContent = i === 1 ? 'Flip to face A' : 'Flip to face B';
    slides.forEach((s, k) => { const v = s.querySelector('video'); if (v) { if (k === i) v.play().catch(() => {}); else v.pause(); } });
  };
  const show = (i, flip) => {
    if (!slides.length) return;
    i = (i + slides.length) % slides.length;
    const s = slides[i];
    if (desk()) { paintGal(i); if (flip) { s.classList.remove('is-flip'); void s.offsetWidth; s.classList.add('is-flip'); } return; }
    track.scrollTo({ left: s.offsetLeft - track.offsetLeft - 16, behavior: 'smooth' });
    paintGal(i);
    if (flip) { s.classList.remove('is-flip'); void s.offsetWidth; s.classList.add('is-flip'); }
  };
  if (track) {
    let raf;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => {
      if (desk()) return;
      const w = slides[0] ? slides[0].offsetWidth + 8 : 1; const i = Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / w)));
      if (i !== cur) paintGal(i);
    }); }, { passive: true });
  }
  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-gal-flip]')) { show(cur === 1 ? 0 : 1, true); return; }
    const t = e.target.closest('[data-thumb]'); if (t) show(Number(t.dataset.thumb));
  });
  /* desktop: click a photo for full screen */
  const zoom = document.querySelector('[data-l-zoom]');
  if (zoom) {
    root.addEventListener('click', (e) => { const im = e.target.closest('.l-gal2__s img'); if (!im || !desk()) return; zoom.querySelector('[data-zoom-img]').src = im.currentSrc || im.src; zoom.hidden = false; document.body.classList.add('l-lock'); });
    zoom.addEventListener('click', () => { zoom.hidden = true; document.body.classList.remove('l-lock'); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !zoom.hidden) { zoom.hidden = true; document.body.classList.remove('l-lock'); } });
  }

  /* ---------- variants ---------- */
  const variants = JSON.parse((document.querySelector('[data-l-variants]') || {}).textContent || '[]');
  const addBtn = $('[data-add]');
  const pAdd = document.querySelector('[data-pbar-add]');
  let variant = variants.find((v) => String(v.id) === addBtn.dataset.variant) || variants[0];
  const setVariant = (v) => {
    if (!v) return;
    variant = v;
    addBtn.dataset.variant = v.id;
    addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
    if (pAdd) pAdd.disabled = !v.available;
    $('[data-price]').textContent = money(v.price);
    const cmp = $('[data-compare]'); cmp.hidden = !(v.compare_at_price > v.price); if (!cmp.hidden) cmp.textContent = money(v.compare_at_price);
    $$('[data-sku]').forEach((s) => { s.textContent = v.sku || ''; });
    const low = $('[data-low]'); if (low) low.hidden = true;
    if (v.featured_media) { const i = slides.findIndex((s) => s.dataset.mediaId == v.featured_media.id); if (i > -1) show(i); }
    peek(v);
    barLabel();
    const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    document.dispatchEvent(new CustomEvent('littl:variant-changed', { detail: { id: v.id } }));
  };
  const opts = $$('[data-opt]');
  /* tap a colour: a larger preview floats over the swatches for a moment (no page jump) */
  const optsBox = $('[data-l-opts]');
  let peekEl, peekT;
  const peek = (v) => {
    if (!optsBox) return;
    const src = (v.featured_image && v.featured_image.src) || (v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src);
    if (!src) return;
    if (!peekEl) { peekEl = document.createElement('div'); peekEl.className = 'l-opt__peek'; peekEl.innerHTML = '<img alt=""><span></span>'; optsBox.appendChild(peekEl); }
    peekEl.querySelector('img').src = src + (src.includes('?') ? '&' : '?') + 'width=400';
    peekEl.querySelector('span').textContent = colourIdx !== null ? v.options[colourIdx] : (v.title || '');
    peekEl.classList.remove('is-on'); void peekEl.offsetWidth; peekEl.classList.add('is-on');
    clearTimeout(peekT); peekT = setTimeout(() => peekEl.classList.remove('is-on'), 1700);
  };
  const colourIdx = (() => { const f = $$('.l-opt__sw').map((sw) => sw.closest('label').querySelector('[data-opt]')); return f.length ? f[0].dataset.opt : null; })();
  const barLabel = () => {
    if (!pAdd) return;
    const q = Math.max(1, parseInt(($('[data-qty]') || {}).value, 10) || 1);
    const name = colourIdx !== null && variant ? variant.options[colourIdx] : '';
    pAdd.innerHTML = `Add <span data-pbar-q>${q}</span>${name ? ` <em class="l-pbar__v">· ${name}</em>` : ''}`;
  };
  const refreshAvail = () => {
    const sel = []; opts.forEach((o) => { if (o.checked) sel[o.dataset.opt] = o.value; });
    opts.forEach((o) => {
      const test = sel.slice(); test[o.dataset.opt] = o.value;
      const ok = variants.some((v) => v.available && v.options.every((val, i) => test[i] === undefined || val === test[i]));
      o.classList.toggle('is-na', !ok);
    });
  };
  opts.forEach((o) => o.addEventListener('change', () => {
    const sel = []; opts.forEach((x) => { if (x.checked) sel[x.dataset.opt] = x.value; });
    const lab = $(`[data-opt-sel="${o.dataset.opt}"]`); if (lab) lab.textContent = o.value;
    setVariant(variants.find((v) => v.options.every((val, i) => val === sel[i])));
    refreshAvail();
  }));
  refreshAvail();

  /* ---------- quantity ---------- */
  const qty = $('[data-qty]');
  const syncQ = () => { const n = Math.max(1, parseInt(qty.value, 10) || 1); qty.value = n; barLabel(); };
  root.addEventListener('click', (e) => { const b = e.target.closest('[data-q]'); if (b) { qty.value = (parseInt(qty.value, 10) || 1) + Number(b.dataset.q); syncQ(); } });
  qty.addEventListener('change', syncQ);

  /* ---------- add to cart ---------- */
  const err = $('[data-err]');
  const add = async (items, btn, doneText) => {
    const orig = btn.innerHTML; btn.disabled = true; if (err) err.hidden = true;
    try {
      const r = await fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const j = await r.json(); if (!r.ok) throw new Error(j.description || 'Could not add to cart');
      const cart = await (await fetch(cartUrl)).json();
      document.dispatchEvent(new CustomEvent('littl:cart-changed', { detail: { cart } }));
      btn.classList.add('is-added'); btn.textContent = doneText || 'Added ✓';
      setTimeout(() => { btn.classList.remove('is-added'); btn.innerHTML = orig; btn.disabled = false; }, 1600);
    } catch (e) {
      btn.innerHTML = orig; btn.disabled = false; if (err) { err.textContent = e.message; err.hidden = false; }
    }
  };
  addBtn.addEventListener('click', () => add([{ id: variant.id, quantity: Number(qty.value) || 1 }], addBtn));
  if (pAdd) pAdd.addEventListener('click', () => add([{ id: variant.id, quantity: Number(qty.value) || 1 }], pAdd));
  root.addEventListener('click', (e) => { const b = e.target.closest('[data-add-both]'); if (b) add([{ id: variant.id, quantity: 1 }, { id: Number(b.dataset.addBoth), quantity: 1 }], b, 'Both added ✓'); });

  /* ---------- floating bar ---------- */
  const threshold = Number(root.dataset.threshold || 99900);
  const paint = (cart) => {
    if (!cart) return;
    const c = document.querySelector('[data-pbar-count]'), v = document.querySelector('[data-pbar-val]'), m = document.querySelector('[data-pbar-msg]'), f = document.querySelector('[data-pbar-fill]');
    if (c) c.textContent = `Cart · ${cart.item_count} ${cart.item_count === 1 ? 'roll' : 'rolls'}`;
    if (v) v.textContent = `${money(cart.total_price)} · View ›`;
    const left = threshold - cart.total_price;
    if (m) m.textContent = left > 0 ? `Add ${money(left)} more for free delivery` : 'You’ve unlocked free delivery ✦';
    if (f) f.style.width = Math.min(100, Math.round(cart.total_price / threshold * 100)) + '%';
  };
  document.addEventListener('littl:cart-changed', (e) => paint(e.detail && e.detail.cart));
  fetch(cartUrl).then((r) => r.json()).then(paint).catch(() => {});

  /* ---------- recommendations ---------- */
  const recs = $('[data-l-recs]');
  if (recs) {
    const load = () => fetch(recs.dataset.url).then((r) => r.text()).then((h) => {
      const d = new DOMParser().parseFromString(h, 'text/html'); const s = d.querySelector('.l-psec'); if (s) recs.replaceWith(s);
    }).catch(() => {});
    if ('IntersectionObserver' in window) { const io = new IntersectionObserver((en) => { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' }); io.observe(recs); } else load();
  }
  paintGal(0);
  barLabel();
})();
